var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0.751993 3.49519 1.89718 2.23177 3.309 1.34938C4.72082 0.466999 6.34429 0 8 0C9.65571 0 11.2792 0.466999 12.691 1.34938C14.1028 2.23177 15.248 3.49519 16 5C15.248 6.50481 14.1028 7.76823 12.691 8.65062C11.2792 9.533 9.65571 10 8 10C6.34429 10 4.72082 9.533 3.309 8.65062C1.89718 7.76823 0.751993 6.50481 0 5ZM8 8.33111C8.86601 8.33111 9.69656 7.98016 10.3089 7.35545C10.9213 6.73075 11.2653 5.88347 11.2653 5C11.2653 4.11653 10.9213 3.26925 10.3089 2.64455C9.69656 2.01984 8.86601 1.66889 8 1.66889C7.13399 1.66889 6.30344 2.01984 5.69108 2.64455C5.07872 3.26925 4.73469 4.11653 4.73469 5C4.73469 5.88347 5.07872 6.73075 5.69108 7.35545C6.30344 7.98016 7.13399 8.33111 8 8.33111ZM8 6.66556C7.56699 6.66556 7.15172 6.49008 6.84554 6.17773C6.53936 5.86537 6.36735 5.44173 6.36735 5C6.36735 4.55827 6.53936 4.13463 6.84554 3.82227C7.15172 3.50992 7.56699 3.33444 8 3.33444C8.43301 3.33444 8.84828 3.50992 9.15446 3.82227C9.46064 4.13463 9.63265 4.55827 9.63265 5C9.63265 5.44173 9.46064 5.86537 9.15446 6.17773C8.84828 6.49008 8.43301 6.66556 8 6.66556Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleEye);
export default __webpack_public_path__ + "static/media/purple_eye.43c244434a26eb2cd8eb66fa8d9eb828.svg";
export { ForwardRef as ReactComponent };